import React, { useEffect } from "react"
import { Box } from "@mui/material"

import { AppBulkEditAction } from "@components/@base/BulkEditDialog"
import { AppDialogCancel } from "@components/@base/Dialog"
import { dsColorNew } from "@palette"
import { username } from "@signals"
import AppNewsDialog from "./Dialog"
import { loadPendingNews, markNewsSeen, pendingNews, pendingNewsIndex } from "./signals"


/**
 * The News popup, mounted in the layout so it shows on whatever page the user lands on. Several
 * pending announcements share one dialog and are paged through instead of stacking.
 *
 * Only the announcements the user reached are marked as seen: "Skip all" (and ×, Escape, a click
 * outside) marks the one on screen and the rest come back on the next app load.
 */
export default function AppNewsPopup() {
	useEffect(() => { loadPendingNews(username.value) }, [username.value])

	const total = pendingNews.value.length
	const index = pendingNewsIndex.value
	const current = pendingNews.value[index]

	if (!current) return null

	const position = index + 1
	const isLast = position >= total

	const next = () => {
		markNewsSeen(current.id_announcement)
		pendingNewsIndex.value = index + 1
	}

	const dismissAll = () => {
		markNewsSeen(current.id_announcement)
		pendingNewsIndex.value = total
	}

	return <AppNewsDialog
		open
		onClose={dismissAll}
		id={current.id_announcement}
		title={current.title}
		date={current.start_at}
		body={current.body}
		footer={<>
			{/* with a single announcement "Close" and "Got it" would be the same button twice */}
			{total > 1 && <AppDialogCancel onClick={dismissAll}>{isLast ? 'Close' : 'Skip all'}</AppDialogCancel>}
			<AppBulkEditAction onClick={isLast ? dismissAll : next}>{isLast ? 'Got it' : 'Next'}</AppBulkEditAction>
		</>}
	>
		{total > 1 && <Box
			aria-label={`Announcement ${position} of ${total}`}
			sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.75, pb: 2, pt: 0.5 }}
		>
			{Array.from({ length: total }, (_, i) => <Box key={i} sx={{
				// the current one stretches instead of only changing colour, so the position reads at a glance
				height: 6, width: i === index ? 18 : 6, borderRadius: 3,
				backgroundColor: i === index ? dsColorNew.appBlue : dsColorNew.grayBorder,
				transition: 'width .2s ease, background-color .2s ease',
			}}/>)}
		</Box>}
	</AppNewsDialog>
}
